import {ISearchStrategy} from '../search-strategy.interface';
import {ILauncherServiceFactory} from '../../../launcher-service-factory.interface';
import {ISearchResultItem} from '../../search-result/search-result-item.interface';
import {FoundSdmGame} from './found-sdm-game';

export class SdmGameSearchStrategy implements ISearchStrategy {
    constructor(private services: ILauncherServiceFactory) {

    }

    search(words: RegExp[]): ISearchResultItem[] {
        let result: ISearchResultItem[] = [];

        this.services.sdm.allGames.forEach(game => {
            if(game.isAllWordsMatch(words)) {
                result.push(new FoundSdmGame(game, this.services));
            }
        });


        return result;
    }

    get searchHintText(): string {
        return 'Search for games';
    }
    get noMatchMessage(): string {
        return 'Your search did not match any game';
    }
}